import Auth from '../Containers/Authentication/Auth';
import Api from './Api';

class FuelTypes {
  async get() {
    const myHeaders = new Headers();
    const endPoint = 'v1/fuel_types';

    myHeaders.append('X-Api-Key', Auth.getBearerToken());

    try {
      const response = await Api.get(endPoint, {
        headers: myHeaders,
      }, true);

      const fuelTypes = response.fuelTypes;
      Api.cache(endPoint, response);
      return fuelTypes;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
}

export default new FuelTypes();



// WEBPACK FOOTER //
// ./src/Services/FuelTypes.js